import React, { useState } from 'react';
import PropTypes from 'prop-types';

const STATUS_CHOICES = {
    IDLE: 0,
    WAITING: 1,
    SUCCESS: 2,
    ERROR: 3,
};

const LoginApp = (props) => {
    const [status, setStatus] = useState({
        type: STATUS_CHOICES.IDLE,
        messages: {}
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        const credentials = $("form[name=credentials]").serialize();
        setStatus({ ...status, ...{ type: STATUS_CHOICES.WAITING }});
        $.post(
            props.loginApiEndpoint,
            credentials,
            (response) => {
                setStatus({
                    ...status,
                    ...{ type: STATUS_CHOICES.SUCCESS, messages: response.messages }
                });
                const queryParams = new URLSearchParams(window.location.search);
                if(queryParams.has("service"))
                    window.location.href = queryParams.get("service");
                else if(queryParams.has("next"))
                    window.location.href = queryParams.get("next");
                else
                    window.location.href = response.login_redirect_url;
            }
        ).fail((response) => {
            console.log(response);
            setStatus({
                ...status,
                ...{
                    type: STATUS_CHOICES.ERROR,
                    messages: response.responseJSON.messages
                }
            });
        });
    };

    return <>
            <div className = 'content-section p-5'>
                <div className = 'py-3'>
                    <h3 className = 'text-light'>Log in</h3>
                    <p className = 'text-light'>If you have an account already</p>
                    <form
                        name = 'credentials'
                        method = "POST"
                        encType = "multipart/form-data"
                        onSubmit = { handleSubmit }
                    >
                        <div className = "form-floating my-2">
                            <input
                                className = {
                                    "form-control " +
                                    (
                                        status.type == STATUS_CHOICES.ERROR ?
                                            'is-invalid' :
                                            status.type == STATUS_CHOICES.SUCCESS ?
                                                'border border-2 border-success' :
                                                ''
                                    )
                                }
                                type = "email"
                                name = "email"
                                placeholder = "Email"
                                id = "email"
                                required 
                            />
                            <label htmlFor = 'username'>Email</label>
                        </div>
                        <div className = "form-floating my-2">
                            <input className = {
                                    "form-control " +
                                    (
                                        status.type == STATUS_CHOICES.ERROR ?
                                            'is-invalid' :
                                            status.type == STATUS_CHOICES.SUCCESS ?
                                                'border border-2 border-success' :
                                                ''
                                    )
                                }
                                type = "password"
                                name = "password"
                                placeholder = "Password"
                                id = "password"
                                required
                            />
                            <label htmlFor = 'password'>Password</label>
                        </div>
                        {
                            status.type == STATUS_CHOICES.WAITING ?
                                <div className = 'text-end'>
                                    <div className = "spinner-border text-light" role = "status">
                                        <span className = "visually-hidden">Loading...</span>
                                    </div>
                                </div> :
                                <div>
                                    {
                                        status.type == STATUS_CHOICES.ERROR ?
                                            <ul className = "text-danger text-end list-unstyled fs-6">
                                                {
                                                    status.messages.map((message, i) => {
                                                        return <li key = { i }>{ message }</li>;
                                                    })
                                                }
                                            </ul> :
                                            null
                                    }
                                    {
                                        status.type == STATUS_CHOICES.SUCCESS ?
                                            <ul className = "text-success text-end list-unstyled fs-6">
                                                {
                                                    status.messages.map((message, i) => {
                                                        return <li key = { i }>{ message }</li>;
                                                    })
                                                }
                                            </ul> :
                                            null
                                    }
                                    <div className = "text-end my-3">
                                        <a className = "link-light fs-6 mx-3" href = { props.passwordResetUrl }>Forgot your password ?</a>
                                        <button className = "btn btn-outline-light" type = "submit">Log In</button>
                                    </div>
                                </div>
                        }
                    </form>
                </div>
                <div className = 'border-top border-2 border-light py-3'>
                    <h3 className = 'text-light'>Register</h3>
                    <p className = 'text-light'>If you don&apos;t have an account already</p>
                    <div className = 'text-end'>
                        <a className = "btn btn-outline-light" href = { props.registerUrl }>
                            Create an account
                        </a>
                    </div>
                </div>
            </div>
    </>;
};

LoginApp.propTypes = {
    loginApiEndpoint: PropTypes.string,
    passwordResetUrl: PropTypes.string,
    registerUrl: PropTypes.string,
};

export default LoginApp;